import {
  CheckOutlined,
  EllipsisOutlined,
  ExclamationOutlined,
  PauseOutlined,
} from '@ant-design/icons';
import { L } from '@lib';
import { Tag } from 'antd';

export const LocalizedServiceOrderStatus = {
  Todo: L('To do'),
  PartsNotOrdered: L('To do - Parts not ordered'),
  PartsOrdered: L('To do - Parts ordered'),
  ReadyToGo: L('To do - Ready to go'),
  InProgress: L('In progress'),
  Approval: L('Estimate'),
  OnHold: L('On hold'),
  Canceled: L('Cancelled'),
  Completed: L('Service completed'),
  Ready: L('Ready for payment'),
  Paid: L('Paid'),
};

export const OrderStatus = {
  Todo: 'Todo',
  PartsNotOrdered: 'PartsNotOrdered',
  PartsOrdered: 'PartsOrdered',
  ReadyToGo: 'ReadyToGo',
  InProgress: 'InProgress',
  Approval: 'Approval',
  OnHold: 'OnHold',
  Canceled: 'Cancelled',
  Completed: 'Completed',
  Ready: 'Ready',
  Paid: 'Paid',
};

export const DropOffDateStatus = {
  Todo: 'Todo',
  PartsNotOrdered: 'PartsNotOrdered',
  PartsOrdered: 'PartsOrdered',
  ReadyToGo: 'ReadyToGo',
  OnHold: 'OnHold',
};

export const ServiceOrderInvoiceStatus = {
  Ready: 'Ready',
  Paid: 'Paid',
};

export const ServiceOrderStatusColor = {
  Todo: '#CDE7FF',
  PartsNotOrdered: '#CDE7FF',
  PartsOrdered: '#CDE7FF',
  Approval: '#FFF1C1',
  InProgress: '#FFF1C1',
  OnHold: '#FFDCDC',
  Completed: '#DEFFCE',
  ReadyToGo: '#CDE7FF',
  Ready: '#DEFFCE',
  Paid: '#F6F6F6',
  Canceled: '#FFDCDC',
};
export const ServiceOrderStatusIcon = {
  Todo: <ExclamationOutlined style={{ fontSize: '0.8em', color: 'rgba(0, 0, 0, 0.65)' }} />,
  PartsNotOrdered: <ExclamationOutlined style={{ fontSize: '0.8em', color: 'rgba(0, 0, 0, 0.65)' }} />,
  PartsOrdered: <ExclamationOutlined style={{ fontSize: '0.8em', color: 'rgba(0, 0, 0, 0.65)' }} />,
  Approval: <PauseOutlined style={{ fontSize: '0.8em', color: 'rgba(0, 0, 0, 0.65)' }} />,
  InProgress: <EllipsisOutlined style={{ fontSize: '0.8em', color: 'rgba(0, 0, 0, 0.65)' }} />,
  OnHold: <PauseOutlined style={{ fontSize: '0.8em', color: 'rgba(0, 0, 0, 0.65)' }} />,
  Completed: <CheckOutlined style={{ fontSize: '0.8em', color: 'rgba(0, 0, 0, 0.65)' }} />,
  ReadyToGo: <CheckOutlined style={{ fontSize: '0.8em', color: 'rgba(0, 0, 0, 0.65)' }} />,
  Ready: <CheckOutlined style={{ fontSize: '0.8em', color: 'rgba(0, 0, 0, 0.65)' }} />,
  Paid: <CheckOutlined style={{ fontSize: '0.8em', color: 'rgba(0, 0, 0, 0.65)' }} />,
  Canceled: <PauseOutlined style={{ fontSize: '0.8em', color: 'rgba(0, 0, 0, 0.65)' }} />,
};

const tagStyle = { minWidth: 200, textAlign: 'center' as const };

export const ServiceOrderStatusTag = {
  Todo: <Tag color="blue" style={tagStyle}>To do</Tag>,
  PartsNotOrdered: <Tag color="blue" style={tagStyle}>To do - Parts not ordered</Tag>,
  PartsOrdered: <Tag color="geekblue" style={tagStyle}>To do - Parts ordered</Tag>,
  ReadyToGo: <Tag color="cyan" style={tagStyle}>To do - Ready to go</Tag>,
  Approval: <Tag color="purple" style={tagStyle}>Estimate</Tag>,
  InProgress: <Tag color="orange" style={tagStyle}>In progress</Tag>,
  OnHold: <Tag color="magenta" style={tagStyle}>On hold</Tag>,
  Completed: <Tag color="green" style={tagStyle}>Completed</Tag>,
  Ready: <Tag color="lime" style={tagStyle}>Ready for payment</Tag>,
  Paid: <Tag color="volcano" style={tagStyle}>Paid</Tag>,
  Canceled: <Tag color="red" style={tagStyle}>Cancelled</Tag>,
};

export const ServiceOrderHistoryStatus = {
  Completed: 'Completed',
  Ready: 'Ready',
  Paid: 'Paid',
};

export type ServiceOrderHistoryStatusObjectKey = keyof typeof ServiceOrderHistoryStatus;
export type ServiceOrderStatusColorObjectKey = keyof typeof ServiceOrderStatusColor;
export type ServiceOrderStatusTagObjectKey = keyof typeof ServiceOrderStatusTag;
export type LocalizedServiceOrderStatusObjectKey = keyof typeof LocalizedServiceOrderStatus;
export type ServiceOrderStatusIconObjectKey = keyof typeof ServiceOrderStatusIcon;
export type ServiceOrderInvoiceStatusObjectKey = keyof typeof ServiceOrderInvoiceStatus;
export type DropOffDateStatusObjectKey = keyof typeof DropOffDateStatus;
